export default "__VITE_ASSET__He4b4E7c__"